import { RecProps } from './types'
import RecommendationsTiles from './components/recommendations'

export const App = (props: RecProps) => {
  return (
    <RecommendationsTiles {... props} />
  )
}
